import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './style.scss';
import { getBannerActive } from 'services/user/bannerService';

const SliderComponent = () => {
  const [banners, setBanners] = useState([])
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true, 
    autoplaySpeed: 3000,
    pauseOnHover: false,
  };

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await getBannerActive()
        setBanners(response.data)
      }
      catch (error) {
        console.log("fetchBanner", error)
      }
    }
    fetchBanner()
  }, [])

  return (
    <div className="image-slider-container">
      <Slider {...settings}>
        {/* <div>
          <img src="https://theme.hstatic.net/200000343865/1001052087/14/ms_banner_img4.jpg?v=1379" alt="" />
        </div>
        <div>
          <img src="https://theme.hstatic.net/200000343865/1001052087/14/ms_banner_img5.jpg?v=1385" alt="" />
        </div>
        <div>
          <img src="https://theme.hstatic.net/200000343865/1001052087/14/ms_banner_img4.jpg?v=1412" alt="" />
        </div>
        <div>
          <img src="https://theme.hstatic.net/200000343865/1001052087/14/ms_banner_img1.jpg?v=1412" alt="" />
        </div> */}
        {banners && (
          banners.map((banner, index) => (
            <div key={index}>
              <img src={banner.image} alt="" />
            </div>
          ))
        )}
      </Slider>
    </div>
  );
}

export default SliderComponent;